module.exports = __webpack_public_path__ + "static/media/ElectionMapSocial.bdaf7e6e.jpg";